import { useTranslation } from "react-i18next";
import {
  getMetricsMinWidth,
  PlayerColumn,
  PlayerSort,
  PLAYER_FIXED_BLOCK_WIDTH,
  PLAYER_LOGO_COLUMN_WIDTH,
  PLAYER_METRIC_COLUMN_WIDTH,
  PLAYER_SIDE_PADDING,
} from "../../utils/playerColumns";
import Dot from "../icons/Dot/Dot";
// import Eye from "../icons/Eye";

interface TableSubheaderProps {
  columns: PlayerColumn[];
  sort: PlayerSort | null;
  onSort: (columnId: string) => void;
}

export default function TableSubheader({
  columns,
  sort,
  onSort,
}: TableSubheaderProps) {
  const { t } = useTranslation();
  const visibleColumns = columns.filter((column) => column.isShow);
  const metricsMinWidth = getMetricsMinWidth(visibleColumns);
  const metricsTemplateColumns =
    visibleColumns.length > 0
      ? `repeat(${visibleColumns.length}, ${PLAYER_METRIC_COLUMN_WIDTH}px)`
      : "none";

  return (
    <div
      className="grid min-w-full w-max bg-[#6886BD66] dark:bg-[#B4EB5466] py-[7px]"
      style={{ gridTemplateColumns: `${PLAYER_FIXED_BLOCK_WIDTH}px auto` }}
    >
      <div
        className="sticky left-0 z-30 flex items-center gap-[25px] font-[600] dark:text-white overflow-hidden bg-[#B6C6E5] dark:bg-[#516A35]"
        style={{
          paddingLeft: `${PLAYER_LOGO_COLUMN_WIDTH + PLAYER_SIDE_PADDING}px`,
          paddingRight: `${PLAYER_SIDE_PADDING}px`,
        }}
      >
        <div>№</div>
        <div className="flex items-center gap-[5px] capitalize whitespace-nowrap">
          {t("names")}
          {/* Names <Eye /> */}
        </div>
      </div>
      <ul
        className="grid w-max"
        style={{
          minWidth: `${metricsMinWidth}px`,
          gridTemplateColumns: metricsTemplateColumns,
          paddingRight: `${PLAYER_SIDE_PADDING}px`,
        }}
      >
        {visibleColumns.map((column) => (
          <li
            className={`${
              sort?.columnId === column.id ? "font-[600]" : ""
            } flex justify-center items-center px-[2px] dark:text-white cursor-pointer select-none`}
            key={column.id}
            onClick={() => onSort(column.id)}
            title={t(column.fullLabel) || column.fullLabel}
          >
            <span className="inline-flex items-center justify-center gap-[5px] text-center leading-[1.1] break-words">
              {column.label} <Dot />
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
